import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, STAFF_ROLES } from "@/context/AuthContext";
import { useI18n } from "@/i18n";

export default function ProtectedRoute({ children, allow = "any" }) {
  const { user, loading } = useAuth();
  const { lang, t } = useI18n();
  const location = useLocation();

  if (loading || user === null) {
    return (
      <div data-testid="auth-loading" className="flex min-h-[60vh] items-center justify-center text-sm text-muted-foreground">
        …
      </div>
    );
  }
  if (!user) {
    return <Navigate to={`/${lang}/login`} state={{ from: location.pathname }} replace />;
  }
  if (allow === "staff" && !STAFF_ROLES.includes(user.role)) {
    return <Navigate to={`/${lang}/portal`} replace />;
  }
  if (allow === "admin" && !["admin", "super_admin"].includes(user.role)) {
    return (
      <div data-testid="access-denied" className="rounded-lg border border-destructive/30 bg-destructive/5 p-6">
        <p className="text-sm font-medium text-destructive">{t("admin.accessDenied")}</p>
      </div>
    );
  }
  if (allow === "candidate" && user.role !== "candidate") {
    return <Navigate to={`/${lang}/admin`} replace />;
  }
  return children;
}
